<h2 mat-dialog-title style="font-size: 20pt; color: darkred;padding-bottom:10px;">WARNING - No emails will be sent for {{studentsWithoutRecipients.length}} students</h2>
<mat-dialog-content>
    <div style="padding-bottom: 10px;">For these students, no email addresses were found for the selected recipient(s).</div>
    <div [ngStyle]="{'height': '350px','overflow':'auto'}" *ngIf="studentsWithoutRecipients.length > 0">
      <mat-table [dataSource]="noEmailWarningDataSources" multiTemplateDataRows matSort matSortDisableClear matSortActive="Name" matSortDirection="asc" id="noEmailDataTable" aria-label="Student Without Recipients Table" style="height: 350px;"
        tabindex="0">
        <ng-container matColumnDef="StudentNumber">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;">
            <span translate>Student #</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let student" style="min-width:100px;">{{student.StudentNumber}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="Name">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;">
            <span translate>Name</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let student" style="min-width:100px;">{{student.Name}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="GradeLevel">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;">
            <span translate>Grade Level</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let student" style="min-width:100px;">{{student.GradeLevel}}</mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true" id="studentdataHeader">
        </mat-header-row>
        <mat-row *matRowDef="let row; columns: columnsToDisplay; let i = index;" id="studentdataRow{{i}}" tabindex="0" [attr.aria-label]="getAriaRow(row)"
          style="padding:0px;overflow:hidden;border-bottom-width:1px;" matRipple>
        </mat-row>

      </mat-table>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class='flex-footer-left'>        
        <tyl-button style="float:right;" image="previous arrow.png" label="Return to Select Recipients" (clickEvent)="backClick()"></tyl-button>      
    </div>
  <div class='flex-footer-right'>
      <tyl-button style="float:right;" image="next arrow.png" label="Proceed to Message Creation" (clickEvent)="nextClick()"></tyl-button>          
  </div>
</mat-dialog-actions>